import type { LC_WorkingDayItemOut, LC_GetWorkingDaysListOut, WorkingDayItem, WorkingDayListResult } from './workingDay.types';


function normalizeWorkingDayStatus(status: string | null | undefined): string {
  const lower = status?.toLowerCase() ?? '';
  if (lower === 'deshabilitado' || lower === 'disabled') return 'disabled';
  if (lower === 'habilitado' || lower === 'enabled') return 'enabled';
  return lower;
}

export function mapWorkingDayItemFromTransport(transport: LC_WorkingDayItemOut): WorkingDayItem {
  return {
    id: transport.id,
    name: transport.name ?? '',
    workingDays: transport.workingDays,
    offDays: transport.offDays,
    workingDayTypeId: transport.workingDayTypeId,
    type: transport.type ?? '',
    status: normalizeWorkingDayStatus(transport.status),
    ordinaryWeeklyHours: transport.ordinaryWeeklyHours,
    ordinaryDailyHours: transport.ordinaryDailyHours,
    weeksInCycle: transport.weeksInCycle,
  };
}

export function mapWorkingDayListFromTransport(
  pagedResult: LC_GetWorkingDaysListOut,
): WorkingDayListResult {
  return {
    items: pagedResult.data?.map(mapWorkingDayItemFromTransport) ?? [],
    totalRecords: pagedResult.pagination?.totalRecords ?? 0,
  };
}
